export const DARK_COLOR = '#404145';
